import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '@/views/Landing.vue'
import GetProjectForm from "@/views/GetProjectForm.vue"
import GetJobForm from "@/views/GetJobForm.vue"
import OrderProductForm from "@/views/OrderProductForm.vue"
import Portfolio from "@/views/Portfolio.vue"
import AboutPage from "@/views/AboutPage.vue"
import Project from "@/views/Project.vue"
import ProductTypePage from '@/views/ProductTypePage.vue'
import PartnerPage from "@/views/PartnerPage.vue"
import ErrorPage from "@/views/ErrorPage.vue"
import Product from "@/views/Product.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing
  },
  {
    path: '/get-project',
    name: 'get-project',
    component: GetProjectForm
  },
  {
    path: '/get-job',
    name: 'get-job',
    component: GetJobForm
  },
  {
    path: '/order-product',
    name: 'order-product',
    component: OrderProductForm
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: Portfolio
  },
  {
    path: '/about',
    name: 'about',
    component: AboutPage
  },
  {
    path: '/project/:id',
    name: 'project',
    component: Project
  },
  {
    path: '/product-type/:id',
    name: 'product-type',
    component: ProductTypePage
  },
  {
    path: '/partner/:id',
    name: 'partner',
    component: PartnerPage
  },
  {
    path: '/404-page',
    name: '404-page',
    component: ErrorPage
  },
  {
    path: '/product/:id',
    name: 'product',
    component: Product
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
